module.exports = "/_next/static/images/google@3x-23fbde6f04d41d3d40f10244da4002b7.png";